import { render, staticRenderFns } from "./LogisticsDialog.vue?vue&type=template&id=49691d14&scoped=true"
import script from "./LogisticsDialog.vue?vue&type=script&lang=js"
export * from "./LogisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./LogisticsDialog.vue?vue&type=style&index=0&id=49691d14&prod&lang=scss&scoped=true"
import style1 from "./LogisticsDialog.vue?vue&type=style&index=1&id=49691d14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49691d14",
  null
  
)

export default component.exports